import { render, staticRenderFns } from "./MemberCallButton.vue?vue&type=template&id=2ea9dde0&"
import script from "./MemberCallButton.vue?vue&type=script&lang=js&"
export * from "./MemberCallButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports